module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Home/Towel-82925761e884559da00df0ea178f86c0.svg";